/** The profile chip: the latest presence label. */
export function presenceChip(data) {
  if (!data?.presenceAsOf) return { status: data?.agent?.presence?.status, text: 'Presence not available yet' };
  return { status: data.agent.presence.status, text: data.agent.presence.label };
}
